import React from "react";
import { Textarea, TextareaProps } from "./textarea";
import { Label } from "./label";
import { siteSettings } from "../../settings/site-settings";

interface TranslatedTextareaProps extends TextareaProps {
  name: string;
  placeholder: string;
  values?: any;
  errors?: any;
  touched?: any;
  columns?: number;
  gapX?: number;
  isEnglishMandatory?: boolean;
  [key: string]: any;
}

export const TranslatedTextarea = ({
  name,
  placeholder,
  values,
  errors,
  touched,
  columns = 1, // Default columns is 1
  gapX = 2, // Default gapX is 2
  isEnglishMandatory = true,
  ...props
}: TranslatedTextareaProps) => {
  return (
    <div className={`w-full grid grid-cols-${columns} gap-x-${gapX}`}>
      {siteSettings.translatedInputs.supportedLanguages.map((lang) => (
        <div key={lang} className={`my-2 flex flex-col items-start`}>
          {/* Custom Label component for each language */}
          <Label
            className="block text-body mb-2 text-sm px-1"
            htmlFor={`${name}.${lang}`}
          >
            {`${placeholder} (${lang.toUpperCase()}) ${
              lang === siteSettings.translatedInputs.defaultLanguage &&
              isEnglishMandatory
                ? "*"
                : ""
            }`}
          </Label>

          {/* Render Textarea for each language */}
          <Textarea
            id={`${name}.${lang}`}
            name={`${name}.${lang}`}
            placeholder={`Enter ${placeholder} in ${lang.toUpperCase()}`}
            error={touched?.[lang] && errors?.[lang] ? errors[lang] : ""}
            value={values?.[lang] || ""}
            className="input-ring bg-transparent text-white placeholder"
            {...props}
          />
        </div>
      ))}
    </div>
  );
};
